// 公共的init函数，每个页面都需要用到的init
import api from './modules/getSetting';
import storage from './util/storage';
import getLoginState from './util/getLoginState';
import { initVisitor, isVisitor } from 'root/common/util/visitor';

// 请求新用户接口
export async function initNewUserFromApi() {
    const isNewUserTimeot = 10 * 60; // 秒
    const token = localStorage.getItem('token');
    if (!token) return;
    const isNewUser = storage.get(storage.keys.isNewUser);
    if (typeof isNewUser === 'boolean' && !isNewUser) return; // 如果不是新用户，不请求了
    const res = await api.isNewUser();
    if (res.code === 200) {
        const value = !!res.data.newcomer;
        const opt = {};
        if (value) opt.expires = isNewUserTimeot + 30; // 如果是老用户了，则不需要设置过期时间了
        // 10分钟过期
        storage.set(storage.keys.isNewUser, value, opt);
        // 10分钟后重新获取
        setTimeout(initNewUser, isNewUserTimeot * 1000);
    }
}

/**
 * 新用户初始化
 */
export function initNewUser() {
    const text = storage.get(storage.keys.isNewUser, { bare: true });
    if (text) {
        try {
            const { expires } = JSON.parse(text);
            if (!expires) return; // 如果没有设置超时，则不重新请求，一直使用旧状态
            const now = new Date();
            let timeout = expires - now.getTime() - 30 * 1000;
            if (timeout > 0) {
                setTimeout(initNewUser, timeout);
                return;
            }
        } catch (error) {
            // 解析出错，重新请求获取
        }
    }
    initNewUserFromApi();
}

/**
 * 新用户初始化 sync
 */
export async function initNewUserSync() {
    const text = storage.get(storage.keys.isNewUser, { bare: true });
    if (text) {
        try {
            const { expires } = JSON.parse(text);
            if (!expires) return; // 如果没有设置超时，则不重新请求，一直使用旧状态
            const now = new Date();
            let timeout = expires - now.getTime() - 30 * 1000;
            if (timeout > 0) {
                setTimeout(initNewUserSync, timeout);
                return;
            }
        } catch (error) {
            // 解析出错，重新请求获取
        }
    }
    await initNewUserFromApi();
}

/**
 * 初始化团长
 */
export function initLeader() {
    const leaderInfo = storage.get(storage.keys.leaderInfo);
    if (!leaderInfo)
        storage.set(storage.keys.leaderInfo, {
            level: 1,
            role: 'leader3',
            lastUpdate: 0,
            abtest: 'a',
        });
    const now = Date.now();
    const timeout = leaderInfo ? 3600 * 1000 - (now - leaderInfo.lastUpdate) : 0;
    setTimeout(async () => {
        await initVisitor();
        if (isVisitor()) return;
        const res = await api.getAgentLeaderInfo();
        if (res.code != 0) return;
        const info = res.data;
        info.lastUpdate = Date.now();
        info.abtest = 'a';
        storage.set(storage.keys.leaderInfo, info);
        initLeader();
    }, timeout);
}

/**
 * 获取团长信息
 * @typedef {Object} LeaderInfo
 * @property {number} level
 * @property {string} role
 * @property {number} lastUpdate
 * @property {'a'|'b'} abtest
 * @returns {LeaderInfo}
 */
export function getLeaderInfo() {
    let leaderInfo = storage.get(storage.keys.leaderInfo) || {
        level: 1,
        role: 'leader3',
        lastUpdate: 0,
        abtest: 'a',
    };
    return leaderInfo;
}

export async function initCardInfo() {
    if (!getLoginState()) return;
    // 兼容之前卡号后端返回'null'的情况
    if (window.localStorage.getItem('card_id') && window.localStorage.getItem('card_id') !== 'null') {
        return;
    }
    const res = await api.getCardInfo();
    if (res.code === 200) {
        const { cardNo, userId } = res.data;
        window.localStorage.setItem('card_id', cardNo);
        window.localStorage.setItem('userId', userId);
    }
}
